import metaModule from "./store";

export default {store: metaModule}